<template>
  <div class="page">
    <Navigation pageName="backups" />
    <!--FILTRI E RICERCA-->
    <form class="filter-section" @submit.prevent="getJobs">
      <div class="filter-left">
        <label class="text-bold">{{ $t("Search") }}</label>
        <input
          type="text"
          class="input bg-white pl-4 text-small"
          v-model.trim="filters.backupName"
          :placeholder="$t('Search for Backup name')"
          v-fsitem
          />            
      </div>
      <div class="filter-left">
        <label class="text-bold">{{ $t("Group") }}</label>
        <select
          class="bg-white pl-2 select text-small"
          data-filter="false"
          v-model="filters.groupSelected"
          @change="setGroupPCs()"
          >
          <option value="">{{ $t("All Groups") }}</option>
          <option
            v-for="group in groups" 
            :value="group"
            :key="group.id_group"
            >
            {{ group.name_group }}
          </option>
        </select>
      </div>
      <!-- Groups -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("Device") }}</label>
        <select
          :disabled="!filters.groupSelected"
          v-disable-tooltip="$t('Select a group to select a device')"
          class="bg-white pl-2 select text-small"
          data-filter="false"
          v-model="filters.id_pc"
          >
          <option value="">{{ $t('All Devices') }}</option>
          <option
            v-for="pc in groupPCs" 
            :value="pc.id"
            :key="pc.id"
            >
            {{ pc.pc_name }}
          </option>
        </select>
      </div>
      <!-- Result (fix order: (value, key)) -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("Result") }}</label>
        <select class="bg-white pl-2 select text-small" v-model="filters.lastResult">
          <option value="">{{ $t('All results') }}</option>
          <option
            v-for="(value, key) in filters.resultList"
            :value="value"
            :key="value"
            >
            {{ $t(key) }}
          </option>
        </select>
      </div>
      <!-- Limit -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("N. of rows") }}</label>
        <select class="bg-white pl-2 select text-small" v-model.number="filters.limit">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
      <!-- Apply filters -->
      <div class="filter-left d-flex flex-align-end">
        <button @click="getJobs()" class="button secondary">
        {{ $t('Filter') }}
        </button>
      </div>
    </form>
    <!--RISULTATI-->
    <div class="results-section">
      <NoDataAvailable
        v-if="jobs != null && jobs.jobs.length == 0"
        :message="$t('No Backups available')"
        />
      <table
        v-if="jobs != null && jobs.jobs.length != 0"
        id="backup-list"
        class="striped compact table w-100 bg-white bordered border overflow"
        >
        <thead>
          <tr class="mb-3">
            <th class="text-center" style="vertical-align: middle; width: 10px;">
              {{ $t('Average Result') }}
            </th>
            <th class="text-center" style="vertical-align: middle; width: 10px;">
              {{ $t('Last Result') }}
            </th>
            <th class="text-left" style="vertical-align: middle; width: 150px;">
              {{ $t('Backup Name') }}
            </th>
            <th class="text-center" style="vertical-align: middle; width: 50px;">
              {{ $t('Type') }}
            </th>
            <th class="text-left" style="vertical-align: middle;">
              {{ $t('Device') }}
            </th>
            <th class="text-right" style="vertical-align: middle; white-space: nowrap;">
              {{ $t('Started') }}/{{ $t('Ended') }}/{{ $t('Duration') }}
            </th>
            <th class="text-center" style="vertical-align: middle; white-space: nowrap;">
              {{ $t('N. of files') }}
            </th>
            <th class="text-center" style="vertical-align: middle;">
              {{ $t('Size') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(backup, index) in jobs.jobs" :key="backup.id + '-' + index">
            <td class="text-center">
              <LastResult :lastresult="backup.average_result" />
            </td>
            <td class="text-center">
              <LastResult :lastresult="backup.last_result" />
            </td>
            <td class="text-left overflow">
              <label
                :title="backup.name"
                class="button flat-button text-bold"
                @click="openBackupView(backup.id)"
                >
              {{ backup.name.length > 50 ? backup.name.substring(0, 50) + '...' : backup.name }}
              </label>
            </td>
            <td class="text-right">
              <span class="badge inline tertiary">
              {{ $ONEServiceTypeInfo[backup.type].name.toUpperCase() }}
              </span>
            </td>
            <td class="text-left">
              <PCLink
                v-if="$session.getPCWithID(backup.id_computer) != null"
                :pc="$session.getPCWithID(backup.id_computer)"
                :seeHealth="true"
                :seeConnectionStatus="true"
                />
            </td>
            <td class="text-right">
              <label v-if="backup.dt_start_utc">{{ backup.dt_start_utc.toLocalDate() }}</label>
              <br />
              <label v-if="backup.dt_end_utc">{{ backup.dt_end_utc.toLocalDate() }}</label>
              <br />
              <label class="text-bold" v-if="backup.dt_end_utc">
              {{ diffDate(backup.dt_start_utc, backup.dt_end_utc) }}
              </label>
            </td>
            <td class="text-center">
              {{ backup.last_backup_copiedfiles }}
            </td>
            <td class="text-center">
              {{ backup.last_backup_size | prettyBytes }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="jobs != null && jobs.jobs.length != 0" class="d-flex flex-justify-between">
        <label class="p-2">
        {{ $t('Page {0} · {1} results', {0:filters.nPage +1, 1:jobs.jobs.length}) }}
        </label>
        <div class="row pr-2 pl-0">
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(filters.nPage-1)"
              :disabled="filters.offset == 0"
              >
            <span class="mif-arrow-left mr-2"></span>{{ $t('Back') }}
            </button>
          </div>
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(0)"
              :disabled="filters.offset == 0"
              >
            {{ $t('First Page') }}
            </button>
          </div>
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(filters.nPage+1)"
              :disabled="!jobs.has_more"
              >
            {{ $t('Next') }}<span class="mif-arrow-right ml-2"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
import { diffDate, fromNow, prettyBytes } from '../utils/utilitiesmodule';
import PCLink from "../components/utils/PCLink.vue";
import LastResult from "../components/utils/LastResult.vue";

export default {
  name: "Backups",
  components: {
    Navigation,
    NoDataAvailable,
    LastResult,
    PCLink,
  },

  data() {
    return {
      jobs: {
        jobs: [],
        has_more: false,
      },
      filters: {
        backupName: '',
        nPage: 0,
        offset: 0,
        lastresult: '',
        status: '',
        id_group: '',
        groupSelected: '',   // oggetto gruppo selezionato
        id_pc: '',
        limit: 25,
        lastResult: '',
        resultList: {},      // popolato in mounted
      },
      sessions: [],
      groups: null,
      computers: [],         // elenco pc completo
      pcsMap: null,
      groupPCs: [],          // pc filtrati per gruppo
      loading: false,
    }
  },

  created() {
    this.$session.setRoomPC(null);
    this.$root.socket("SETPC", null);

    this.groups=this.$session.getGroups();
    this.computers=this.$session.getPCList(); // (era commentato)
  },

  mounted() {
    this.getJobs();
    this.filters.resultList=this.$ResultValue;
    this.pcsMap=this.$session.getPCList().toMap("id");
  },

  filters: {
    prettyBytes(bytes, precision) {
      return prettyBytes(bytes, precision);
    },
  },

  methods: {
    openBackupView(idBackup) {
      this.idBackupInView=idBackup;
      this.$root.$emit("OPENBACKUPVIEW", idBackup);
    },

    openMenu() {
      Metro.getPlugin('#remotemenu', 'dropdown').open();
    },


    fromNow(date) {
      if (!date) return "";
      return fromNow(date, this.$moment);
    },
    diffDate(datestart, dateend) {
      return diffDate(datestart, dateend, this.$moment);
    },

    // Applica i filtri e carica i jobs
    getJobs() {
      this.loading=true;
      this.filters.offset=this.filters.nPage*this.filters.limit
      // reset device se non c'è un gruppo selezionato
      if (!this.filters.groupSelected) {
        this.filters.id_pc="";
      }

      // imposta id_group in base al gruppo selezionato
      this.filters.id_group=this.filters.groupSelected
        ? this.filters.groupSelected.id_group
        :"";

      this.$api.getBackups(this.filters)
        .then(jobs => {
          this.jobs=jobs;
          this.loading=false;
        })
        .catch(error => {
          console.writeError(error);
          this.loading=false;
        });
    },

    // Aggiorna la lista pc in base al gruppo scelto
    setGroupPCs() {
      const group=this.filters.groupSelected||null;

      // aggiorna subito i campi, così la combo device si abilita
      this.filters.id_group=group? group.id_group:'';
      this.filters.id_pc='';

      if (!group||!Array.isArray(group.ids_computers)||group.ids_computers.length===0) {
        this.groupPCs=[];
        return;
      }

      // filtra pc per id del gruppo
      this.groupPCs=this.computers.filter(c => group.ids_computers.includes(c.id));
    },
    changePage(nPage) {
      this.filters.nPage=nPage;
      this.getJobs();
    }
  }
}
</script>
